<template>
	<Card :bordered="false" class="card-container">
		<div class="content"  @click='handleClickDetail(dataModel)'>
			<!-- VR -->
			<div v-if="dataModel.vrUrl" @click='vrClick(dataModel.vrUrl)' style="position: absolute;top: 0;left: 0;width: 220px;height: 150px;">
				<img
				style="width: 50px;margin: 50px 85px;"
				src="../../assets/images/icon_VR@2x.png"/>
			</div>
			<!-- VR -->
			<img class="list-cover" :src="dataModel.surveyTakePictures[0]"/>
			<div class="list-right">
				
				<div class="list-title">{{dataModel.louName}}   {{dataModel.estateName}}  {{dataModel.remark}}</div>
				<div class="list-title"
					v-if='dataModel.slogan'
					style="width: 100%; text-overflow: -o-ellipsis-lastline; overflow: hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 1; line-clamp: 1; -webkit-box-orient: vertical;">
					{{dataModel.slogan}} 	
				</div>
				<div class="list-between">
					
					<div class="list-tag-container">
						<Tag v-for="(tagItem,tagIndex) in dataModel.tags" :key='tagItem'>{{tagItem}}</Tag>
					</div>
					<div v-if="dataModel.typeCode == 'buy'">
						<div class="list-price" v-show="showType==1" v-if="dataModel.totalPrice.length > 4">{{dataModel.totalPrice/10000}}万元</div>
						<div class="list-price" v-show="showType==1" v-else>{{dataModel.totalPrice}}元</div>
					</div>
					<div v-if="dataModel.typeCode == 'rent'">
						<div class="list-price" >{{dataModel.monthlyRent}}元/月</div>
					</div>
				</div>
				<div class="list-between">
					
					<div class="list-desc" style="display: flex;">
						<span v-if="dataModel.floorNo/dataModel.floorQuantity <= 1/3">低楼层/共{{ dataModel.floorQuantity }}层</span>
						<span v-else-if="1/3 < dataModel.floorNo/dataModel.floorQuantity <= 2/3">中楼层/共{{ dataModel.floorQuantity }}层</span>
						<span v-else-if="2/3 < dataModel.floorNo/dataModel.floorQuantity <= 1">高楼层/共{{ dataModel.floorQuantity }}层</span>
						<span >{{ dataModel.bedroomQuantity }}室{{ dataModel.drawingroomQuantity }}厅{{ dataModel.washroomQuantity }}卫</span>
						<span>{{ dataModel.decorationTypeName }}</span>
						<span>{{ dataModel.houseAcreage }}㎡</span>
					</div>
					<div v-if="dataModel.typeCode == 'buy'">
						<div :class="[showType==2 ? 'list-price':'list-unit-price']" v-if="dataModel.lowPrice">{{dataModel.lowPrice}}元/㎡</div>
						<div :class="[showType==2 ? 'list-price':'list-unit-price']" v-else>{{ Number(dataModel.totalPrice/dataModel.houseAcreage).toFixed(2) }}元/㎡</div>
					</div>
					
				</div>
				<div class="list-region" v-show="showType==2">{{dataModel.estateAddr}}</div>
			</div>
		</div>
		
		
	</Card>

</template>

<script>
	
import { Card,Tag } from 'iview'

export default {
	name:"JcHouseList",
	props: {
		showType:{
			type:Number,
			default:null
		},/// 1 二手房  2 小区、新房  3 好房出租 商铺写字楼
		dataModel: {
			type: Object,
			default: {
				"cover":"",
				"title":"",
				"tags":[],
				"desc":"",
				"price":"",
				"unitPrice":"",
				"region":"",
			},
		},
	},
	components:{
		Card,
		Tag
	},
	methods:{
		/// 查看详情
		handleClickDetail(item) {
			if(this.showType == 1){
				window.open('/pc/index.html#/houseDetailMange-secondHandHouse?houseId='+item.houseId)
				// this.$router.push({
				// 	path:"/houseDetailMange-secondHandHouse",
				// 	query:{
				// 		houseId:item.houseId
				// 	}
				// })
			}else if(this.showType == 2){
				window.open('/pc/index.html#/houseDetailMange-newHouse?estateId='+item.estateId)
				// this.$router.push({
				// 	path:"/houseDetailMange-newHouse",
				// 	query:{
				// 		estateId:item.estateId
				// 	}
				// })
			}else if(this.showType == 3){
				window.open('/pc/index.html#/houseDetailMange-leaseHouse?houseId='+item.houseId)
				// this.$router.push({
				// 	path:"/houseDetailMange-leaseHouse",
				// 	query:{
				// 		houseId:item.houseId
				// 	}
				// })
			}
		},
		vrClick(url){
			let tiaoUrl = 'http://'+url
			if(url.indexOf('http') == -1){
				tiaoUrl = 'http://'+url
			}else{
				tiaoUrl = url
			}
			
			
			window.open(tiaoUrl)
		}
	}
}
</script>

<style scoped="scoped" lang="less">
	@import './index.less';
</style>
